import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-center bg-gray-200 px-2 py-1"},[_c(VIcon,{attrs:{"size":"16"}},[_vm._v("$NotebookEdit")]),_c('span',{staticClass:"font-14 ml-1"},[_vm._v("Ficha técnica de produção")])],1),_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-clipboard-list-outline")]),_vm._v("\n      Relação de Produtos Acabados\n    ")],1),_c(VTabItem,{staticClass:"px-1"},[_c(VCard,{attrs:{"elevation":"5"}},[_c('ProdutoAcabado',{attrs:{"chamarInitialize":_vm.atualizarPA}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }